import React from "react";
import aboutImage from "../assets/otherimages/aboutus-img.png";
import qualityIcon from "../assets/otherimages/quality.svg";
import priceIcon from "../assets/otherimages/price.svg";
import bookingIcon from "../assets/otherimages/booking.svg";
import { Helmet } from "react-helmet";
const AboutUs = () => {
  return (

    <>
    <Helmet>
        <title>About Us | Blue Diamond Rent Car Dubai</title>
        <meta
          name="description"
          content="Learn about Blue Diamond Rent Car — offering flexible, affordable car rental services across Dubai and UAE."
        />
        <link rel="canonical" href="https://bluediamondrentcar.com/about" />
      </Helmet>

      <section
      id="about"
      className="py-16 px-4 sm:px-8 lg:px-20 xl:px-28 bg-gray-50"
    >
      <div className="container mx-auto">
        {/* Title */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#0B2F6B]">
            ABOUT US
          </h2>
          <p className="text-[#123775] mt-2 text-lg md:text-xl">
            Personal & Commercial Rent a Car Service in Dubai
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-[40%_60%] xl:grid-cols-2 gap-12 lg:gap-20 xl:gap-18 items-center">
          {/* Image */}
          <div className="flex justify-center">
            <img
              src={aboutImage}
              alt="Blue Diamond Rent a Car"
              className="w-full max-w-xs sm:max-w-md lg:max-w-sm xl:max-w-md rounded-[2rem]"
              loading="lazy"
            />
          </div>

          {/* Text */}
          <div className="text-left">
            <p className="text-gray-800 leading-relaxed mb-8 text-sm sm:text-base">
              Blue Diamond Rent A Car offers flexible and affordable rental cars
              across the UAE, with daily, weekly, monthly, and yearly packages
              for both personal and commercial needs. Our mission is to provide
              hassle-free booking, quality vehicles, and transparent pricing so
              you only pay for what you need, when you need it. Whether it’s a
              short trip or a long-term rental, we deliver value, flexibility,
              and peace of mind.
            </p>

            {/* Features */}
            <div className="space-y-6">
              {/* Feature 1 */}
              <div
                className="
                  flex flex-col text-center lg:gap-4 md:gap-3 sm:gap-0
                  bg-blue-50 rounded-2xl p-6 shadow
                  sm:flex-row sm:items-start sm:text-left
                  sm:bg-transparent sm:rounded-none sm:p-0 sm:shadow-none
                "
              >
                {/* Icon */}
                <div className="flex justify-center sm:justify-start mb-4 sm:mb-0">
                  {/* Mobile: plain icon | Tablet+: square with border */}
                  <div className="sm:w-12 sm:h-12 flex items-center justify-center sm:bg-blue-50 sm:rounded-xl sm:border-[#4D7DB4] sm:border-t-4 sm:border-l-4 sm:shadow">
                    <img
                      src={qualityIcon}
                      alt="Quality Choice"
                      className="h-10 w-10 sm:h-5 sm:w-5"
                      loading="lazy"
                    />
                  </div>
                </div>
                {/* Text */}
                <div>
                  <h4 className="font-semibold text-gray-900">
                    Quality Choice
                  </h4>
                  <p className="text-gray-600 text-sm sm:text-base">
                    We offer a variety of high-quality vehicles, including
                    luxury cars, SUVs, and vans.
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div
                className="
                  flex flex-col text-center lg:gap-4 md:gap-3 sm:gap-0
                  bg-blue-50 rounded-2xl p-6 shadow
                  sm:flex-row sm:items-start sm:text-left
                  sm:bg-transparent sm:rounded-none sm:p-0 sm:shadow-none
                "
              >
                <div className="flex justify-center sm:justify-start mb-4 sm:mb-0">
                  <div className="sm:w-12 sm:h-12 flex items-center justify-center sm:bg-blue-50 sm:rounded-xl sm:border-[#4D7DB4] sm:border-t-4 sm:border-l-4 sm:shadow">
                    <img
                      src={priceIcon}
                      alt="Affordable Prices"
                      className="h-10 w-10 sm:h-5 sm:w-5"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">
                    Affordable Prices
                  </h4>
                  <p className="text-gray-600 text-sm sm:text-base">
                    You can select rental packages that suit your budget and
                    duration.
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div
                className="
                  flex flex-col text-center lg:gap-4 md:gap-3 sm:gap-0
                  bg-blue-50 rounded-2xl p-6 shadow
                  sm:flex-row sm:items-start sm:text-left
                  sm:bg-transparent sm:rounded-none sm:p-0 sm:shadow-none
                "
              >
                <div className="flex justify-center sm:justify-start mb-4 sm:mb-0">
                  <div className="sm:w-12 sm:h-12 flex items-center justify-center sm:bg-blue-50 sm:rounded-xl sm:border-[#4D7DB4] sm:border-t-4 sm:border-l-4 sm:shadow">
                    <img
                      src={bookingIcon}
                      alt="Online Booking"
                      className="h-10 w-10 sm:h-5 sm:w-5"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">
                    Convenient Online Booking
                  </h4>
                  <p className="text-gray-600 text-sm sm:text-base">
                    Our easy online booking lets customers reserve a car
                    anytime, anywhere.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
    
  );
};

export default AboutUs;
